import { Building } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconBuilding12Line = createIcon(Building, 12, "Line");
export const IconBuilding16Line = createIcon(Building, 16, "Line");
export const IconBuilding20Line = createIcon(Building, 20, "Line");
export const IconBuilding24Line = createIcon(Building, 24, "Line");
export const IconBuilding32Line = createIcon(Building, 32, "Line");
export const IconBuilding48Line = createIcon(Building, 48, "Line");
export const IconBuilding64Line = createIcon(Building, 64, "Line");
